import { useI18n } from "@/i18n/I18nContext";
import { LANGUAGES } from "@/i18n/translations";
import { Languages } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export default function LanguageSwitcher({ variant = "ghost" }) {
  const { lang, setLang } = useI18n();
  const current = LANGUAGES.find((l) => l.code === lang) || LANGUAGES[0];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid="language-switcher-trigger"
          className="flex items-center gap-1.5 rounded-lg border border-white/10 bg-secondary/70 px-3 py-2 text-sm hover:border-white/25 transition-colors"
        >
          <Languages className="h-4 w-4" />
          <span>{current.flag}</span>
          <span className="hidden sm:inline">{current.code.toUpperCase()}</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="bg-popover border-white/10">
        {LANGUAGES.map((l) => (
          <DropdownMenuItem
            key={l.code}
            data-testid={`language-option-${l.code}`}
            onClick={() => setLang(l.code)}
            className="cursor-pointer gap-2"
          >
            <span>{l.flag}</span>
            <span>{l.label}</span>
            {l.code === lang && <span className="ml-auto text-primary">•</span>}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
